"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discount = void 0;
const types_1 = require("@hoepel.app/types");
class Discount {
    constructor(props) {
        this.props = props;
    }
    toProps() {
        return this.props;
    }
    static fromProps(props) {
        return new Discount(props);
    }
    static createRelativeDiscount(name, percent) {
        const discountPercent = Math.round(Math.min(100, Math.max(percent, 0)));
        return new Discount({
            name,
            discount: {
                kind: 'relative-discount',
                discountPercent: isNaN(discountPercent) ? 0 : discountPercent,
            },
        });
    }
    static createAbsoluteDiscount(name, price) {
        return new Discount({
            name,
            discount: {
                kind: 'absolute-discount',
                discountCents: price.totalCents,
            },
        });
    }
    static sorted(discounts) {
        return [...discounts].sort((a, b) => a.name.localeCompare(b.name));
    }
    /**
     * Apply a list of discounts to a price. The discounts will be applied in the array order.
     *
     * The result will never be negative (always at least 0.00EUR)
     *
     * @param to The price to apply these discounts to
     * @param discounts The list of discounts to be applied
     */
    static applyAllDiscounts(to, discounts) {
        return discounts.reduce((acc, current) => {
            return current.applyTo(acc);
        }, to);
    }
    /**
     * Applies this discount to a price.
     * The result will never be negative (always at least 0.00EUR)
     */
    applyTo(price) {
        switch (this.props.discount.kind) {
            case 'absolute-discount': {
                return price.subtract(this.absoluteDiscount);
            }
            case 'relative-discount': {
                const pct = this.discountPercentage * 0.01;
                return price.multiply(1 - pct);
            }
        }
    }
    get isRelativeDiscount() {
        return this.props.discount.kind === 'relative-discount';
    }
    get isAbsoluteDiscount() {
        return this.props.discount.kind === 'absolute-discount';
    }
    /**
     * Return the discount as a percentage ([0,100]).
     * If this discount is an absolute discount, returns 0%
     */
    get discountPercentage() {
        switch (this.props.discount.kind) {
            case 'absolute-discount':
                return 0;
            case 'relative-discount':
                return this.props.discount.discountPercent;
        }
    }
    /**
     * Return the absolute discount as a price to be substracted
     * If this discount is a relative discount, returns 0.00EUR
     */
    get absoluteDiscount() {
        switch (this.props.discount.kind) {
            case 'absolute-discount':
                return types_1.Price.fromCents(this.props.discount.discountCents);
            case 'relative-discount':
                return types_1.Price.zero;
        }
    }
    get name() {
        return this.props.name;
    }
    withName(name) {
        return Discount.fromProps({
            ...this.toProps(),
            name,
        });
    }
}
exports.Discount = Discount;
//# sourceMappingURL=discount.js.map